export default __webpack_public_path__ + "static/media/virtual-general-counsel.a9bdd94e.jpg";